import React, { useEffect, useReducer } from "react";
import sa3 from "../../reducers/sa3";
import * as action from "../../actions/sa3";
// import LineChart from "./LineChart";
// import ScatterChart from "./ScatterChart";
import { LoadIndicator } from "devextreme-react/load-indicator";
import moment from "moment";
import SA3 from "./SA3";
import { forEach } from "lodash";
import ConfirmedResultPrint from "./ConfirmedResultPrint";
const stateInit = { printInfoA3: null };
export default (props: any) => {
  const [state, dispatch] = useReducer(sa3, stateInit);
  let { printInfoA3 } = state;
  let { id, title } = props;

  useEffect(() => {
    if (id) action.fetchPrintInfoA3(dispatch, id);
  }, [id]);

  const getHtmData = (d: any) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `${d}`,
        }}
      ></div>
    );
  };
  console.log(printInfoA3);

  const Box1 = () => {
    let {
      strategicObjective,
      problemStatement,
      trigger,
      done,
      inScope,
      outofScope,
    } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 1 - &nbsp;Reason for Action</h2>
        <div>
          <label>Strategic Objective: </label>
          <span className="print-val">{strategicObjective}</span>
        </div>
        <div>
          <label>Problem Statement: </label>
          <span className="print-val">{problemStatement}</span>
        </div>
        <div>
          <label>Trigger: </label>
          <span className="print-val">{trigger}</span>
        </div>
        <div>
          <label>Done: </label>
          <span className="print-val">{done}</span>
        </div>
        <div>
          <label>In Scope: </label>
          <span className="print-val">{inScope}</span>
        </div>
        <div>
          <label>Out Of Scope: </label>
          <span className="print-val">{outofScope}</span>
        </div>
      </div>
    );
  };
  const Box9 = () => {
    let {
      whatWentWell,
      whatNotWentWell,
      whatHindered,
      whatHelped,
      lessonLearnt,
    } = printInfoA3;
    return (
      <div className="items bx9">
        <h2>Box 9 - &nbsp; Insights & Actions</h2>
        <div>
          <label>What went well?: </label>
          <span className="print-val">{whatWentWell}</span>
        </div>
        <div>
          <label>What didnt go well?: </label>
          <span className="print-val">{whatNotWentWell}</span>
        </div>
        <div>
          <label>What helped?: </label>
          <span className="print-val">{whatHelped}</span>
        </div>
        <div>
          <label>What hindered?: </label>
          <span className="print-val">{whatHindered}</span>
        </div>
        <div>
          <label>Where can lessons learnt be applied?: </label>
          <span className="print-val">
            {lessonLearnt ? lessonLearnt.substring(0, 500) : ""}
          </span>
        </div>
      </div>
    );
  };
  const Box2 = () => {
    let { kpistates } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 2 - &nbsp;Initial State</h2>

        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>Type</th>
                <th>Key Performance Indicator</th>
                <th>Baseline</th>
              </tr>
            </thead>
            {kpistates && kpistates.length > 0 && (
              <tbody>
                {kpistates.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.type}</td>
                    <td>{d.kpi}</td>
                    <td>{d.baseline}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    );
  };

  const Box3 = () => {
    let { kpistates } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 3 - &nbsp;Target State</h2>
        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>Type</th>
                <th>Key Performance Indicator</th>
                <th>Percentage</th>
                <th>Up/Down</th>
                <th>Target</th>
              </tr>
            </thead>
            {kpistates && kpistates.length > 0 && (
              <tbody>
                {kpistates.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.type}</td>
                    <td>{d.kpi}</td>
                    <td>{d.percentage}</td>
                    <td>{d.updown}</td>
                    <td>{d.target}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    );
  };

  const Box4 = () => {
    let { gapAnalysisData } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 4 - &nbsp;GAP Analysis</h2>
        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>Gap Number</th>
                <th>Gap (Description)</th>
              </tr>
            </thead>
            {gapAnalysisData && gapAnalysisData.length > 0 && (
              <tbody>
                {gapAnalysisData.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.gapNumber}</td>
                    <td>{d.gapDescription}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    );
  };

  const Box5 = () => {
    let { gapsolutions } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 5 - &nbsp;Solution Approach</h2>
        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>GAP #</th>
                <th>Solution ID</th>
                <th>Solution</th>
                <th>Expected Improvement</th>
                <th>Owner</th>
                <th>Benefit</th>
                <th>Difficulty</th>
                <th>PICK Status</th>
              </tr>
            </thead>
            {gapsolutions && gapsolutions.length > 0 && (
              <tbody>
                {gapsolutions.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.causeID}</td>
                    <td>{d.solutionId}</td>
                    <td>{d.solution}</td>
                    <td>{d.expectedImprovement}</td>
                    <td>{d.owner}</td>
                    <td>{d.benefit}</td>
                    <td>{d.difficulty}</td>
                    <td>{d.pickStatus}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
        {/* {lsRCASolution && lsRCASolution.length > 0 &&
                <div className="soln_chart">
                    <ScatterChart solutionData={lsRCASolution} chartId="print_sa_chart" isPrint={true} />
                </div>
            } */}
      </div>
    );
  };

  const Box6 = () => {
    let { rapidExperiments, isRapidExperiment } = printInfoA3;
    return (
      <div className="items">
        <h2>Box 6 - &nbsp;Rapid Experiment</h2>
        <div>
          <label>Not applicable: </label>
          <span className="print-val">{isRapidExperiment ? "Yes" : "No"}</span>
        </div>
        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>Experiment Description</th>
                <th>Expected Results</th>
                <th>Due Date</th>
                <th>Actual Results</th>
              </tr>
            </thead>
            {rapidExperiments && rapidExperiments.length > 0 && (
              <tbody>
                {rapidExperiments.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.experimentDesc}</td>
                    <td>{d.expectedResults}</td>
                    <td>{d.dueDate}</td>
                    <td>{d.actualResults}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    );
  };

  const printDate = () => moment().format("MM/DD/YYYY");

  const Box7 = () => {
    let { completionPlans } = printInfoA3;
    return (
      <div className="items lt">
        <h2>Box 7 - &nbsp;Completion Plan</h2>
        <div>
          <table className="print-sps-tbl">
            <thead>
              <tr>
                <th>Task</th>
                <th>Metric</th>
                <th>Due Date</th>
                <th>Owner</th>
                <th>Completed Date</th>
                <th>Status</th>
                <th>Andon</th>
              </tr>
            </thead>
            {completionPlans && completionPlans.length > 0 && (
              <tbody>
                {completionPlans.map((d: any, i: any) => (
                  <tr key={i}>
                    <td>{d.task}</td>
                    <td>{d.metric}</td>
                    <td>{d.dueDate}</td>
                    <td>{d.owner}</td>
                    <td>{d.completedOn}</td>
                    <td>{d.status}</td>

                    <td>
                      <span className="addon" style={{ background: d.andon }}>
                        {" "}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    );
  };

  const Box8 = () => {
    let {
      kpiResult,
      resultFrequency,
      resultEndDate,
      resultStartDate,
      kpiunits,
    } = printInfoA3;
    return (
      <div className="items lt">
        <h2>Box 8 - &nbsp;Confirmed Results</h2>
        <div className="ds-flx cr-info">
          <div>
            <label>Start Date: </label>
            <span className="print-val" style={{ fontSize: "12px" }}>
              {resultStartDate}
            </span>
          </div>
          <div>
            <label>End Date: </label>
            <span className="print-val" style={{ fontSize: "12px" }}>
              {resultEndDate}
            </span>
          </div>
        </div>
        <div>
          <label style={{ paddingLeft: "10px" }}>Reporting Frequency: </label>
          <span className="print-val" style={{ fontSize: "12px" }}>
            {resultFrequency}
          </span>
        </div>
        <div className="ds-flx">
          <div style={{ width: "70%" }}>
            <table className="print-sps-tbl">
              <thead>
                <tr>
                  <th style={{ width: "120px" }}>KPI</th>
                  <th style={{ width: "35px" }}>Target (%)</th>
                  <th style={{ width: "35px" }}>AOP</th>
                  <th style={{ width: "35px" }}>Actual (%)</th>
                  <th style={{ width: "35px" }}>Andon</th>
                </tr>
              </thead>
              {kpiResult && kpiResult.length > 0 && (
                <tbody>
                  {kpiResult.map((d: any, i: any) => (
                    <tr key={i}>
                      <td>{d.kpiName}</td>
                      <td>{d.target}</td>
                      <td>{d.aop}</td>
                      <td>{d.actual}</td>
                      <td>
                        <span className="addon" style={{ background: d.andon }}>
                          {" "}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
          {/* <div style={{ width: '59%' }}>
                    {lsResult && lsResult.length > 0 ? (
                        <LineChart
                            target="Target"
                            actual="Actual"
                            chartId="print_rslt"
                            chartData={lsResult}
                        />
                    ) : null}
                </div> */}
        </div>
      </div>
    );
  };

  const Page2 = () => {
    let {
      processOwnerName,
      coachName,
      startDate,
      dueDate,
      areaToSolve,
      problemToSolve,
      teamMemberData,
      closeDate,
    } = printInfoA3;

    return (
      <table className="back-page">
        <tbody>
          <tr>
            <td>Process Owner</td>
            <td>{processOwnerName}</td>
          </tr>
          <tr>
            <td>Approver</td>
            <td>{coachName}</td>
          </tr>
          <tr>
            <td>Start Date</td>
            <td>{startDate}</td>
          </tr>
          <tr>
            <td>Due Date</td>
            <td>{dueDate}</td>
          </tr>
          <tr>
            <td>Close Date</td>
            <td>{closeDate ? closeDate : ""}</td>
          </tr>
          <tr>
            <td>Area to Solve</td>
            <td>{areaToSolve}</td>
          </tr>
          <tr>
            <td>Problem to Solve</td>
            <td>{problemToSolve}</td>
          </tr>
          <tr>
            <td>Team Members</td>
            <td>
              {/* {teamMemberData[0].memberName} */}
              {teamMemberData &&
                teamMemberData.length > 0 &&
                teamMemberData.map((d: any, index: any) => (
                  <>
                    <span>{d.memberName}</span> <span>,</span>{" "}
                  </>
                ))}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  return printInfoA3 ? (
    <>
      <h3 className="print-head">Front Page</h3>
      <div className="f-p-titl">
        <div
          className="print-title"
          style={{ width: "80%", textAlign: "center" }}
        >
          {title}
        </div>
        <div style={{ width: "20%", textAlign: "right", paddingRight: "20px" }}>
          {printDate()}
        </div>{" "}
      </div>
      <div className="box">
        <div style={{ width: "30%" }} className="items-flx">
          <Box1 />
          <Box2 />
          <Box3 />
        </div>
        <div style={{ width: "32%" }} className="items-flx">
          <Box4 />
          <Box5 />
          <Box6 />
        </div>
        <div style={{ width: "30%" }} className="items-flx">
          <Box7 />
          <Box8 />
          <Box9 />
        </div>
      </div>
      <h3 className="print-head">Back Page</h3>
      <div className="f-p-titl">
        <div
          className="print-title"
          style={{ width: "80%", textAlign: "center", fontSize: "22px" }}
        >
          {title}
        </div>
        <div style={{ width: "20%", textAlign: "right", paddingRight: "20px" }}>
          {printDate()}
        </div>{" "}
      </div>
      <div className="b-box">
        {" "}
        <div style={{ width: "80%", marginTop: "20%" }}>
          <Page2 />
        </div>
      </div>
      <div className="b-box" style={{ height: "100%" }}>
        {" "}
        <div
          style={{ width: "90%", marginTop: "15%", backgroundColor: "white" }}
        >
          <ConfirmedResultPrint a3ID={id} />
        </div>
      </div>
    </>
  ) : !id ? (
    <h3>
      Print preview not available at the momemt. Please save the General details
      to view the Print Preview.
    </h3>
  ) : (
    <LoadIndicator className="button-indicator" visible={true} />
  );
};
